import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";
import { withRouter } from "../../utils/withRouter";
import Select from "react-select";

class LandingForm extends Component {
  constructor(props) {
    super(props);
    const { id } = props.router.params || {};
    this.isEditMode = Boolean(id);

    this.state = {
      id: id || null,
      products: [],

      formData: {
        product_id: "",
        title: "",
        page_url: "",
        web_page_data: "", // as plain text (no GrapesJS)
        public_status: "1",
      },

      loading: this.isEditMode,
      saving: false,
      errors: {},
    };
  }

  componentDidMount() {
    this.fetchProducts();
    if (this.isEditMode) this.fetchLanding(this.state.id);
  }

  fetchProducts = async () => {
    try {
      const res = await axios.get("/products");
      if (res.data.status === "success") {
        // keep minimal product info for select
        this.setState({ products: res.data.data || [] });
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load products", "error");
    }
  };

  fetchLanding = async (id) => {
    try {
      const res = await axios.get(`/landings/${id}`);
      if (res.data.status === "success") {
        const d = res.data.data;
        this.setState({
          formData: {
            product_id: d.product_id ?? "",
            title: d.title ?? "",
            page_url: d.page_url ?? "",
            web_page_data: d.web_page_data ?? "",
            public_status: String(d.public_status ?? "0"),
          },
          loading: false,
        });
      } else {
        Swal.fire("Error", res.data.message || "Landing not found", "error");
        this.setState({ loading: false });
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to fetch landing", "error");
      this.setState({ loading: false });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
    }));
  };

  validate = () => {
    const errors = {};
    const { title, page_url } = this.state.formData;
    if (!title || title.trim() === "") errors.title = "Title is required";
    if (!page_url || page_url.trim() === "") errors.page_url = "Page URL is required";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.validate()) {
      Swal.fire("Validation error", "Please fix the form errors", "error");
      return;
    }

    this.setState({ saving: true });
    const payload = { ...this.state.formData };

    try {
      let res;
      if (this.isEditMode) {
        res = await axios.put(`/landings/${this.state.id}`, payload);
      } else {
        res = await axios.post("/landings", payload);
      }

      if (res.data.status === "success") {
        Swal.fire("Success", res.data.message || (this.isEditMode ? "Updated" : "Created"), "success");
        this.props.router.navigate("/admin/landings");
      } else {
        Swal.fire("Error", res.data.message || "Save failed", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to save landing", "error");
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const { products, formData, loading, saving, errors } = this.state;
    const productOptions = products;

    if (loading) return <div className="text-center p-4">Loading...</div>;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="card shadow-sm">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">{this.isEditMode ? "Edit Landing" : "Create Landing"}</h5>
                <Link to="/admin/landings" className="btn btn-light-warning">
                  Landing List
                </Link>
            </div>

            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="mb-3">
                  <label className="form-label small">Product</label>
                  <Select
                    name="product_id"
                    options={products.map((p) => ({
                      value: p.id,
                      label: `${p.product_name} — ৳${p.sales_price}`,
                    }))}
                    value={
                      formData.product_id
                        ? {
                            value: formData.product_id,
                            label:
                              products.find((p) => p.id === formData.product_id)?.product_name +
                              " — ৳" +
                              products.find((p) => p.id === formData.product_id)?.sales_price,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      this.setState((prev) => ({
                        formData: { ...prev.formData, product_id: selected?.value || "" },
                      }))
                    }
                    isClearable
                  />
                </div>


                <div className="mb-3">
                  <label className="form-label small">Title <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    name="title"
                    className={`form-control form-control-sm ${errors.title ? "is-invalid" : ""}`}
                    value={formData.title}
                    onChange={this.handleChange}
                  />
                  {errors.title && <div className="invalid-feedback">{errors.title}</div>}
                </div>

                <div className="mb-3">
                  <label className="form-label small">Page URL <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    name="page_url"
                    className={`form-control form-control-sm ${errors.page_url ? "is-invalid" : ""}`}
                    value={formData.page_url}
                    onChange={this.handleChange}
                    placeholder="example-slug or full path"
                  />
                  {errors.page_url && <div className="invalid-feedback">{errors.page_url}</div>}
                </div>

                <div className="mb-3">
                  <label className="form-label small">Web Page Data (JSON / text)</label>
                  <textarea
                    name="web_page_data"
                    className="form-control form-control-sm"
                    rows="6"
                    value={formData.web_page_data}
                    onChange={this.handleChange}
                    placeholder='Optional: saved GrapesJS JSON or HTML fragments'
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label small">Public Status</label>
                  <select
                    name="public_status"
                    className="form-control form-control-sm"
                    value={formData.public_status}
                    onChange={this.handleChange}
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>

                <div className="d-flex gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-light border"
                    onClick={() => this.props.router.navigate("/admin/landings")}
                    disabled={saving}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={saving}>
                    {saving ? "Saving..." : this.isEditMode ? "Update Landing" : "Create Landing"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LandingForm);
